import { useCallback, useEffect, useState } from 'react';
import { TAB_HUBS } from '../components/shell/constants';

// Top-level routing state for the workspace:
//   tab    : which top-level tab is selected ('proposition' | 'engaging' | 'delivery')
//   active : which hub's detail overlay is open (slug | null)
//   context: opaque slug passed to the coach — `active` if open, else the tab's first hub
//
// handleGoto(slug) is the cross-link CTA fired by the coach. It finds which tab
// owns the slug, switches tab, then opens the detail overlay after 60ms (the
// delay lets the tab-change effect fire `setActive(null)` first so we don't
// open + close + open in one render cycle).

export function useTabRouting(initialTab = 'proposition') {
  const [tab, setTab] = useState(initialTab);
  const [active, setActive] = useState(null);

  // Tab change always closes any open overlay.
  useEffect(() => {
    setActive(null);
  }, [tab]);

  const handleGoto = useCallback((slug) => {
    const owningTab = Object.entries(TAB_HUBS).find(([, slugs]) => slugs.includes(slug))?.[0];
    if (!owningTab) return;
    setTab(owningTab);
    setTimeout(() => setActive(slug), 60);
  }, []);

  const context = active ?? TAB_HUBS[tab]?.[0] ?? 'hub';

  return { tab, setTab, active, setActive, handleGoto, context };
}
